import React from 'react';
import { block } from '../../utils/cn';
import { ShareListItem } from '../ShareListItem/ShareListItem';
import { Icon } from '../../Icon';
import { Button } from '../../Button';
import { Link } from '../../icons';
import { CopyToClipboard, CopyToClipboardStatus } from '../../CopyToClipboard';
import { isOfType } from '../../utils/isOfType';
import i18n from '../i18n';
import './ShareList.css';
const b = block('share-list');
const isShareListItemComponent = isOfType(ShareListItem);
export class ShareList extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            copied: false,
        };
        this.copyLink = null;
        this.copyLinkRef = (element) => {
            this.copyLink = element;
        };
    }
    componentDidMount() {
        if (this.props.withCopyLink && this.copyLink) {
            this.copyLink.style.width = `${this.copyLink.scrollWidth}px`;
        }
    }
    render() {
        const { socialNets, withCopyLink, className, direction, children } = this.props;
        const hasNets = Array.isArray(socialNets) && socialNets.length > 0;
        const extensions = React.Children.toArray(children).filter((child) => isShareListItemComponent(child));
        return (React.createElement("div", { className: b({ layout: direction }, className) },
            hasNets && this.renderSocialShareLinks(),
            Boolean(extensions === null || extensions === void 0 ? void 0 : extensions.length) && extensions,
            hasNets && withCopyLink && React.createElement("div", { className: b('separator') }),
            withCopyLink && this.renderCopyLink()));
    }
    renderSocialShareLinks() {
        const { url, title, text, socialNets, direction } = this.props;
        return (React.createElement("div", { className: b('social') }, socialNets.map((type) => (React.createElement(ShareListItem, { key: type, type: type, url: url, title: title, text: text, className: b('link'), direction: direction })))));
    }
    renderCopyLink() {
        const { copied } = this.state;
        const label = copied ? i18n('label_copy-link-copied') : i18n('label_copy-link');
        return (React.createElement(CopyToClipboard, { text: this.props.url, timeout: 1500 }, (status) => (React.createElement(Button, { ref: this.copyLinkRef, className: b('copy-link'), view: "flat-secondary", size: "l", disabled: status === CopyToClipboardStatus.Success, width: "max" },
            React.createElement(Icon, { data: Link, size: 16 }),
            label))));
    }
}
ShareList.defaultProps = {
    socialNets: [],
    withCopyLink: false,
};
ShareList.Item = ShareListItem;
